import type { Components, Theme } from "@mui/material";

// TODO: create `readOnly` style

export const MuiOutlinedInput: Components<Theme>["MuiOutlinedInput"] = {
	styleOverrides: {
		root: ({ theme }) => ({
			borderRadius: theme.spacing(2),
		}),
	},
	variants: [
		{
			// Leave props empty for default
			props: {},
			style: ({ theme }) => ({
				"&.Mui-disabled": {
					backgroundColor: theme.palette.muted.light,
					input: {
						color: theme.palette.text.soft,
						cursor: "not-allowed",
						WebkitTextFillColor: theme.palette.text.soft,
					},
				},
			}),
		},
		{
			props: { size: "small", multiline: false },
			style: ({ theme }) => ({
				minHeight: theme.spacing(5.5),
				"& input": { minHeight: theme.spacing(3.25) },
			}),
		},
		{
			props: { size: "small", multiline: true },
			style: ({ theme }) => ({
				minHeight: theme.spacing(5.5),
				"& input": { minHeight: theme.spacing(3.25) },
			}),
		},
		{
			props: { size: "medium", multiline: false },
			style: ({ theme }) => ({
				minHeight: theme.spacing(6),
				"& input": { minHeight: theme.spacing(1.75) },
			}),
		},
		{
			props: { size: "medium", multiline: true },
			style: ({ theme }) => ({
				minHeight: theme.spacing(6),
				"& input": { minHeight: theme.spacing(1.75) },
			}),
		},
		{
			props: { color: "primary" },
			style: ({ theme }) => ({
				backgroundColor: theme.palette.secondary.main,
				borderColor: theme.palette.border,
			}),
		},
	],
};
